(function () {
  if (window.TrustpilotProduct) return;

  const API_BASE_URL = 'https://helsegrossisten-wfi.wecode.dev';
  const cache = new Map();

  function fetchProductReview({ trustpilot_sku }) {
    const sku = String(trustpilot_sku || '').trim();
    if (!sku) {
      return Promise.resolve({ reviews: [], averageRating: 0, totalReviews: 0 });
    }

    if (cache.has(sku)) return cache.get(sku);

    const request = fetch(`${API_BASE_URL}/api/product-review`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        trustpilot_sku: sku,
      }),
    }).then((response) => {
      if (!response.ok) {
        throw new Error(`Request failed: ${response.status}`);
      }
      return response.json();
    });

    const guarded = request.catch((error) => {
      cache.delete(sku);
      throw error;
    });

    cache.set(sku, guarded);
    return guarded;
  }

  function renderStars(rating) {
    const numericRating = Number(rating) || 0;
    const fullStars = Math.floor(numericRating);
    const partialPercent = Math.round((numericRating - fullStars) * 100);
    const emptyStars = 5 - fullStars - (partialPercent > 0 ? 1 : 0);

    let html = '<span class="trustpilot-product-rating__stars" aria-hidden="true">';

    for (let i = 0; i < fullStars; i += 1) {
      html += '<span class="star filled">★</span>';
    }

    if (partialPercent > 0) {
      html += `<span class="star partial" style="--fill-percentage: ${partialPercent}%">★</span>`;
    }

    for (let i = 0; i < emptyStars; i += 1) {
      html += '<span class="star empty">☆</span>';
    }

    html += '</span>';
    return html;
  }

  class TrustpilotProductRating extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      if (!this.dataset.trustpilotSku) return;

      fetchProductReview({
        trustpilot_sku: this.dataset.trustpilotSku,
      })
        .then((payload) => this.render(payload))
        .catch((error) => {
          console.error('Failed to fetch Trustpilot product rating:', error);
        });
    }

    render({ averageRating = 0, totalReviews = 0 } = {}) {
      const rating = Number(averageRating) || 0;
      const count = Number(totalReviews) || 0;

      if (!rating || !count) {
        this.hidden = true;
        this.innerHTML = '';
        return;
      }

      const formattedRating = rating.toFixed(1);
      const reviewsTarget = document.getElementById('trustpilot-reviews');
      const content = `
        ${renderStars(rating)}
        <span class="trustpilot-product-rating__number">${formattedRating}/5</span>
      `;

      if (reviewsTarget) {
        this.innerHTML = `<a class="trustpilot-product-rating__link" href="#trustpilot-reviews">${content}</a>`;
        this.querySelector('a')?.addEventListener('click', (event) => {
          event.preventDefault();
          const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          reviewsTarget.scrollIntoView({
            behavior: prefersReducedMotion ? 'auto' : 'smooth',
            block: 'start',
          });
        });
      } else {
        this.innerHTML = `<span class="trustpilot-product-rating__link">${content}</span>`;
      }

      this.setAttribute(
        'aria-label',
        `Trustpilot ${formattedRating} ud af 5, baseret på ${count} anmeldelser`
      );
      this.hidden = false;
    }
  }

  if (!customElements.get('trustpilot-product-rating')) {
    customElements.define('trustpilot-product-rating', TrustpilotProductRating);
  }

  window.TrustpilotProduct = {
    fetchProductReview,
    renderStars,
  };
})();
